import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

@Component({
  standalone: true,
  selector: 'wrt-editor-atom',
  imports: [CommonModule, EditorModule, ReactiveFormsModule],
  providers: [{ provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }],
  templateUrl: './wrt-editor.atom.html',
  styleUrls: ['./wrt-editor.atom.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WrtEditorAtom implements OnInit {
  @Input() editable = true;
  Math = Math;
  isSmallScreen = window.innerWidth <= 768;
  @Input() inputControl = new FormControl();
  @Output() saveEvent = new EventEmitter();
  @Input() enableAlign = false;
  @Input() data!: any;
  constructor() {}

  ngOnInit(): void {
    // console.log('cai nay dang render truoc khi co data nen ko update ui kip');
  }

  // onEditorCreated(quill: Quill) {
  //   if (this.enableAlign || !this.inputControl.value) {
  //     quill.format('align', 'justify');
  //   }
  //   console.log('quill', quill, this.inputControl);

  // addBindingCreated(quill: Quill) {
  //   // quill.keyboard.addBinding({
  //   //   key: 'b'
  //   // }, (range, context) => {
  //   //   // tslint:disable-next-line:no-console
  //   //   console.log('KEYBINDING B', range, context)
  //   // })

  //   quill.keyboard.addBinding(
  //     {
  //       key: 'E',
  //       ctrlKey: true,
  //     } as any,
  //     (range, context) => {
  //       // tslint:disable-next-line:no-console
  //       // console.log('KEYBINDING CTRL + E', range, context, quill);
  //       quill.formatLine(range.index, range.length, 'align', 'center', 'user');
  //     }
  //   );

  //   quill.keyboard.addBinding(
  //     {
  //       key: 'L',
  //       ctrlKey: true,
  //     } as any,
  //     (range, context) => {
  //       // tslint:disable-next-line:no-console
  //       // console.log('KEYBINDING CTRL + L', range, context, quill);
  //       quill.formatLine(range.index, range.length, 'align', '', 'user');
  //     }
  //   );

  //   quill.keyboard.addBinding(
  //     {
  //       key: 'R',
  //       ctrlKey: true,
  //     } as any,
  //     (range, context) => {
  //       // tslint:disable-next-line:no-console
  //       // console.log('KEYBINDING CTRL + R', range, context, quill);
  //       quill.formatLine(range.index, range.length, 'align', 'right', 'user');
  //     }
  //   );

  //   quill.keyboard.addBinding(
  //     {
  //       key: 'J',
  //       ctrlKey: true,
  //     } as any,
  //     (range, context) => {
  //       // tslint:disable-next-line:no-console
  //       // console.log('KEYBINDING CTRL + J', range, context, quill);
  //       quill.formatLine(range.index, range.length, 'align', 'justify', 'user');
  //     }
  //   );

  //   quill.keyboard.addBinding(
  //     {
  //       key: 'S',
  //       ctrlKey: true,
  //     } as any,
  //     (range, context) => {
  //       // tslint:disable-next-line:no-console
  //       // console.log('KEYBINDING CTRL + J', range, context, quill);
  //       this.saveEvent.emit();
  //     }
  //   );
  // }

  // selectOnSomeText(event: any) {
  // console.log('event', event);
  // event.quill.formatLine(event.range.index, event.range.length, 'align', 'right');
  // }
}
